import { AriaLivePoliteness } from '@angular/cdk/a11y';
import { InjectionToken, ViewContainerRef } from '@angular/core';
import { Direction } from '@angular/cdk/bidi';

/** Injection token that can be used to access the data that was passed in to a toast. */
export const FINRA_TOAST_DATA = new InjectionToken<any>('FinraToastData');

/** Possible values for horizontalPosition on ToastConfig. */
export type ToastHorizontalPosition = 'start' | 'center' | 'end' | 'left' | 'right';

/** Possible values for verticalPosition on ToastConfig. */
export type ToastVerticalPosition = 'top' | 'bottom';

export class ToastConfig<D = any> {
    /**
     * Message to be announced by the LiveAnnouncer. When opening a toast without a custom
     * component or template, the announcement message will default to the specified message.
     */
    // tslint:disable-next-line
    announcementMessage?: string = '';

    /** The politeness level for the MatAriaLiveAnnouncer announcement. */
    politeness?: AriaLivePoliteness = 'assertive';

    /** Data being injected into the child component. */
    data?: D | null = null;

    /** Text layout direction for the snack bar. */
    direction?: Direction;

    /** The length of time in milliseconds to wait before automatically dismissing the toast. */
    duration = 0;

    /** The horizontal position to place the toast. */
    horizontalPosition?: ToastHorizontalPosition = 'center';

    /** The vertical position to place the taost. */
    verticalPosition?: ToastVerticalPosition = 'bottom';

    /** Extra CSS classes to be added to the toast container. */
    panelClass?: string | string[];


    /** The view container to place the overlay for the toast into. */
    viewContainerRef?: ViewContainerRef;
}
